// extracted by mini-css-extract-plugin
export var chevronIcon = "_b3-2";
export var teamName = "_b3-1";
export var teamSwitcherButton = "_b3-0";